export var clickableStyle = function (theme) { return ({
    position: 'relative',
    cursor: 'pointer',
    '&:before': {
        top: 0,
        left: 0,
        position: 'absolute',
        content: '""',
        height: '100%',
        width: '100%',
        borderRadius: 'inherit',
        backgroundColor: 'currentColor',
        pointerEvents: 'none',
        transition: theme.transitions.create('opacity'),
        opacity: 0,
    },
    '&:hover:before': {
        opacity: 0.1,
    },
    '&:active:before': {
        opacity: 0.2,
    },
}); };
